export default {
  403: {
    tips: '抱歉，您无权限访问此页面，企业微信联系创建者',
    back: '返回首页',
  },
  404: {
    subtitle: '抱歉，您访问的页面不存在',
    back: '返回首页',
  },
  500: {
    subtitle: '抱歉，服务器出错啦',
    back: '返回首页',
  },
  fail: {
    title: '创建失败',
    subtitle: '抱歉，您的项目创建失败，企业微信联系检查创建者权限，或返回修改。',
    back: '回到首页',
    modify: '返回修改',
  },
  success: {
    title: '项目已创建成功',
    subtitle: '可以联系负责人分发应用',
    back: '回到首页',
    progress: '查看进度',
  },
  maintenance: {
    title: '系统维护中',
    subtitle: '系统维护中，请稍后再试',
    back: '回到首页',
  },
  browserIncompatible: {
    title: '浏览器不兼容',
    subtitle: '抱歉，您正在使用的浏览器版本过低，无法打开当前网页。',
    back: '回到首页',
    recommend: '医疗加压管理平台推荐以下主流浏览器',
  },
  networkError: {
    title: '网络异常',
    subtitle: '网络异常, 请稍后重试',
    back: '回到首页',
    reload: '重新加载',
  },
};
